<template>
  <v-card class="hide-overflow" v-if="product">
    <v-toolbar color="transparent" flat>
      <v-btn icon @click="close()" v-if="!isCDS">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="close()" v-if="isCDS && product.showBack">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ product.name }}</v-toolbar-title>
    </v-toolbar>

    <v-container class="mb-5">
      <v-layout wrap>
        <v-flex xs10 offset-xs1 sm5 offset-sm0>
          <!-- <carousel :perPage="1" :navigationEnabled="true" ref="productSlides">
                <slide v-for="(image,img_index) in productImages" :key="'image_'+img_index">
                  <v-responsive :aspect-ratio="1">
                    <v-img :src="image" alt></v-img>
                  </v-responsive>
                </slide>
          </carousel>-->
          <template v-if="currentPhoto">
            <v-img
              :src="currentPhoto"
              :lazy-src="currentPhoto"
              aspect-ratio="1"
              class="grey lighten-2"
              style="max-width: 300px; margin:auto"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </template>
          <hooper v-show="!currentPhoto">
            <slide
              v-for="(image, img_index) in productImages"
              :key="'image_' + img_index"
              style="text-align: center"
            >
              <div
                style="position: relative; height: 100%"
                @click="
                  currentPreview = image;
                  showPreview = true;
                "
              >
                <img :src="image" style="height: 100%; margin: auto" />
                <div
                  style="position: absolute; top: 50%;left: 50%; margin-left: -28px; margin-top: -28px"
                >
                  <v-btn class="ma-0" depressed fab dark color="rgb(0, 0, 0, 0.2)">
                    <v-icon>mdi-magnify-plus-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </slide>

            <pagination
              slot="hooper-addons"
              mode="fraction"
              style="background: #00000057;border-radius: 50px;color: white;"
            ></pagination>

            <navigation slot="hooper-addons"></navigation>
          </hooper>

          <!-- <vueper-slides
            :slide-ratio="1"
            ref="productSlides"
            :dragging-distance="70"
          >
            <vueper-slide
              v-for="(image, img_index) in productImages"
              :key="'image_' + img_index"
              :image="image"
            >
              <div slot="slideContent">
                <v-layout>
                  <v-btn
                    depressed
                    fab
                    dark
                    color="rgb(0, 0, 0, 0.2)"
                    @click="
                      currentPreview = image;
                      showPreview = true;
                    "
                  >
                    <v-icon>mdi-magnify-plus-outline</v-icon>
                  </v-btn>
                  <!- <div>
                        <div>{{ image }}</div>
                  </div>->
                </v-layout>
              </div>
            </vueper-slide>
          </vueper-slides>-->

          <v-dialog scrollable v-model="showPreview" max-width="690">
            <v-card v-if="currentPreview">
              <v-card-actions class="text-xs-right">
                <v-layout>
                  <v-flex>
                    <v-btn flat fab icon small @click="showPreview = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
              <v-card-text class="pa-0">
                <v-zoom :img="currentPreview" :width="'100%'"></v-zoom>
              </v-card-text>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-dialog>
          <div class="mb-4 hidden-sm-and-up"></div>
        </v-flex>
        <v-flex xs12 sm6 offset-sm1 class="hidden-sm-and-up">
          <h4 class="name mb-2">{{ product.name }}</h4>

          <div class>
            <template v-if="productstock && productstock.length > 0">
              <h3 class="headline price" :style="{ color: theme.color }">
                <template
                  v-if="
                    option != null &&
                      option[3] !=
                        calculateBundlePrice(
                          option[3],
                          totalBundle + quantity,
                          isWholesale ? wholesale : productbundle
                        )
                  "
                >
                  {{ currencySign
                  }}{{
                    calculateBundlePrice(
                      option[3],
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    ) | decimalFormat
                  }}
                </template>
                <template v-else-if="option != null && option[3] > option[4]"
                  >{{ currencySign }}{{ option[4] | decimalFormat }}</template
                >
                <template v-else-if="option != null"
                  >{{ currencySign }}{{ option[3] | decimalFormat }}</template
                >
              </h3>
              <div
                class="discount"
                v-if="
                  option != null &&
                    (option[3] > option[4] ||
                      option[3] !=
                        calculateBundlePrice(
                          option[3],
                          totalBundle + quantity,
                          isWholesale ? wholesale : productbundle
                        ))
                "
              >
                {{ currencySign }}{{ option[3] | decimalFormat }}
              </div>
              <div v-else>&nbsp;</div>
            </template>
            <template v-else>
              <h3 class="headline price" :style="{ color: theme.color }">
                <template
                  v-if="
                    product.price !=
                      calculateBundlePrice(
                        product.price,
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                  "
                >
                  {{ currencySign
                  }}{{
                    calculateBundlePrice(
                      product.price,
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    ) | decimalFormat
                  }}
                </template>
                <template v-else-if="product.price > product.discountprice"
                  >{{ currencySign }}{{ product.discountprice | decimalFormat }}</template
                >
                <template v-else
                  >{{ currencySign }}{{ product.price | decimalFormat }}</template
                >
              </h3>
              <div
                class="discount"
                v-if="
                  product.price > product.discountprice ||
                    product.price !=
                      calculateBundlePrice(
                        product.price,
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                "
              >
                {{ currencySign }}{{ product.price | decimalFormat }}
              </div>
              <div v-else>&nbsp;</div>
            </template>
          </div>
        </v-flex>

        <v-flex xs12 sm6 offset-sm1>
          <div class="hidden-xs-only">
            <h4 class="name mb-2">{{ product.name }}</h4>

            <div class="mb-4">
              <template v-if="productstock && productstock.length > 0">
                <h3 class="headline price" :style="{ color: theme.color }">
                  <template
                    v-if="
                      option != null &&
                        option[3] !=
                          calculateBundlePrice(
                            option[3],
                            totalBundle + quantity,
                            isWholesale ? wholesale : productbundle
                          )
                    "
                  >
                    {{ currencySign
                    }}{{
                      calculateBundlePrice(
                        option[3],
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      ) | decimalFormat
                    }}
                  </template>

                  <template v-else-if="option != null && option[3] > option[4]"
                    >{{ currencySign }}{{ option[4] | decimalFormat }}</template
                  >
                  <template v-else-if="option != null"
                    >{{ currencySign }}{{ option[3] | decimalFormat }}</template
                  >
                </h3>
                <div
                  class="discount"
                  v-if="
                    option != null &&
                      (option[3] > option[4] ||
                        option[3] !=
                          calculateBundlePrice(
                            option[3],
                            totalBundle + quantity,
                            isWholesale ? wholesale : productbundle
                          ))
                  "
                >
                  {{ currencySign }}{{ option[3] | decimalFormat }}
                </div>
                <div v-else>&nbsp;</div>
              </template>
              <template v-else>
                <h3 class="headline price" :style="{ color: theme.color }">
                  <template
                    v-if="
                      product.price !=
                        calculateBundlePrice(
                          product.price,
                          totalBundle + quantity,
                          isWholesale ? wholesale : productbundle
                        )
                    "
                  >
                    {{ currencySign
                    }}{{
                      calculateBundlePrice(
                        product.price,
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      ) | decimalFormat
                    }}
                  </template>
                  <template v-else-if="product.price > product.discountprice">
                    {{ currencySign }}{{ product.discountprice | decimalFormat }}
                  </template>
                  <template v-else
                    >{{ currencySign }}{{ product.price | decimalFormat }}</template
                  >
                </h3>
                <div
                  class="discount"
                  v-if="
                    product.price > product.discountprice ||
                      product.price !=
                        calculateBundlePrice(
                          product.price,
                          totalBundle + quantity,
                          isWholesale ? wholesale : productbundle
                        )
                  "
                >
                  {{ currencySign }}{{ product.price | decimalFormat }}
                </div>
                <div v-else>&nbsp;</div>
              </template>
            </div>
          </div>

          <div v-if="productstock" class="mb-4 mt-2">
            <div v-if="!isKhaiwhan || (isKhaiwhan && productstock && productstock.length > 1)">
              <v-item-group multiple flat>
                <template
                  v-if="
                    (isCDS || (pageProfile && pageProfile.pageid == '100335904735928')) &&
                      productstockcategories &&
                      productstockcategories.length > 0
                  "
                >
                  <product-option
                    v-if="!loadingProduct"
                    v-model="currentOption"
                    :stock="productstock"
                    :category="productstockcategories"
                    @changeOption="onChangeOption"
                  ></product-option>
                </template>
                <template v-else>
                  <template v-for="(stype, sindex) in productstock">
                    <!-- <v-btn
                    depressed
                    round
                    class="ma-0 mr-2 mb-2"
                    
                    >{{ stype[1] }}</v-btn
                  > -->
                    <v-chip
                      :key="'stock_' + sindex"
                      depressed
                      @focus="
                        onViewStockPhoto(stype[7]);
                        option = stype;
                        quantity = 1;
                      "
                      @blur="onViewStockPhoto(null)"
                      :disabled="parseInt(stype[2]) < 1"
                      @click="onChangeOption(stype[1])"
                      :dark="option && stype[0] == option[0]"
                      :color="option && stype[0] == option[0] ? theme.color : ''"
                    >
                      <v-avatar v-if="stype[7]">
                        <img :src="stype[7]" :alt="stype[1]" />
                      </v-avatar>
                      {{ stype[1] }}
                    </v-chip>
                  </template>
                </template>
              </v-item-group>
            </div>
            <div v-if="isKhaiwhan">
              <v-text-field
                v-model="optionkhaiwhan"
                :color="theme.color"
                outline
                placeholder="เช่น ไม่ใส่ไข่กุ้ง"
                label="รายละเอียดเพิ่มเติม"
              ></v-text-field>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <v-divider class="mt-4 mb-4"></v-divider>
        </v-flex>
        <v-flex xs12 class="mb-5">
          <div class="body-1">
            <h3 class="headline name mb-2" :style="{ color: theme.color }">
              {{ $t("Product Detail") }}
            </h3>
            <nl2br tag="div" :text="product.description" class="description"></nl2br>
          </div>
        </v-flex>
      </v-layout>

      <div :class="{ 'has-error': errors.has('customerName') }" class="mb-1">
        <v-text-field
          :label="$t('Name')"
          :data-vv-as="$t('Name')"
          outline
          name="customerName"
          v-validate="'required'"
          v-model="customerName"
          light
          :color="theme.color"
          :error="errors.has('customerName') ? true : false"
          :error-messages="errors.has('customerName') ? errors.first('customerName') : ''"
        ></v-text-field>
      </div>

      <div :class="{ 'has-error': errors.has('bookbanknumber') }" class="mb-1">
        <v-text-field
          outline
          :label="$t('เลขบัญชี Forex')"
          name="bookbanknumber"
          :data-vv-as="$t('เลขบัญชี Forex')"
          style="resize: none;width:100%"
          v-model="shippingAddress"
          v-validate="{
            required: true,
            numeric: true,
          }"
          light
          :color="theme.color"
          :error="errors.has('bookbanknumber') ? true : false"
          :error-messages="errors.has('bookbanknumber') ? errors.first('bookbanknumber') : ''"
        ></v-text-field>
      </div>

      <div :class="{ 'has-error': errors.has('customerPhone') }" class="mb-1">
        <v-text-field
          :label="$t('Tel.')"
          :data-vv-as="$t('Tel.')"
          outline
          tyle="tel"
          name="customerPhone"
          light
          :color="theme.color"
          v-validate="{
            required: true,
            regex: /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/,
          }"
          v-model="customerPhone"
          :error="errors.has('customerPhone') ? true : false"
          :error-messages="errors.has('customerPhone') ? errors.first('customerPhone') : ''"
        ></v-text-field>
      </div>

      <div style="height: 60px"></div>
    </v-container>

    <v-card style="position: fixed;z-index: 3;bottom: 0;left: 0; right: 0">
      <v-layout wrap>
        <v-flex xs4 class="pa-3">{{ $t("Total") }}</v-flex>
        <v-flex xs8 class="text-xs-right pa-3">
          <template v-if="productstock.length > 0">
            <template
              v-if="
                option != null &&
                  option[3] !=
                    calculateBundlePrice(
                      option[3],
                      totalBundle + quantity,
                      isWholesale ? wholesale : productbundle
                    )
              "
            >
              <span
                class="discount mr-1"
                v-if="
                  option != null &&
                    option[3] !=
                      calculateBundlePrice(
                        option[3],
                        totalBundle + quantity,
                        isWholesale ? wholesale : productbundle
                      )
                "
              >
                {{ currencySign }}{{ (option[3] * quantity + additional_price) | decimalFormat }}
              </span>
              <template v-if="option != null">
                {{ currencySign
                }}{{
                  (calculateBundlePrice(
                    option[3],
                    totalBundle + quantity,
                    isWholesale ? wholesale : productbundle
                  ) *
                    quantity +
                    additional_price)
                    | decimalFormat
                }}
              </template>
            </template>
            <template v-else-if="option != null && option[3] > option[4]">
              <span class="discount mr-1">
                {{ currencySign }}{{ (option[3] * quantity + additional_price) | decimalFormat }}
              </span>
              {{ currencySign }}{{ (option[4] * quantity + additional_price) | decimalFormat }}
            </template>
            <template v-else>
              <template v-if="option != null">
                {{ currencySign }}{{ (option[3] * quantity + additional_price) | decimalFormat }}
              </template>
            </template>
          </template>
          <template v-else>
            {{ currencySign }}
            <template v-if="product.price > product.discountprice">
              {{ (product.discountprice * quantity + additional_price) | decimalFormat }}
            </template>
            <template v-else>{{
              (product.price * quantity + additional_price) | decimalFormat
            }}</template>
          </template>
        </v-flex>
        <v-flex xs12>
          <v-btn
            depressed
            dark
            large
            :loading="loading || loadingCart || loadingProduct"
            :color="theme.color"
            v-if="!isOutOfStock"
            @click="addToCart"
            :class="{ disabled: isOutOfStock }"
            :disabled="isOutOfStock || !option"
            style="width: 100%;border-radius: 0;height: 55px"
            class="ma-0"
          >
            <v-icon>mdi-cart-plus</v-icon>&nbsp;
            <span>{{ $t("แจ้งรับ Cashback") }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
import { Hooper, Slide, Pagination, Navigation } from "hooper";
import "hooper/dist/hooper.css";

import { mapGetters } from "vuex";

import $ from "jquery";
import config from "@/config";
import axios from "axios";
import ModalProduct from "@/components/ecommerce/ModalProduct.vue";
import Modal from "@/components/Modal.vue";
import ModalImage from "@/components/ModalImage.vue";
import numeral from "numeral";
import ProductOption from "./ProductOption";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import Nl2br from "vue-nl2br";
// import { Carousel, Slide } from "vue-carousel";

import vZoom from "vue-zoom";
import { bearhousepackagehasbubble, bearhousebubbletea } from "@/assets/js/BearHouse.js";

export default {
  props: ["value", "products", "pageProfile", "loadingCart"],
  data() {
    return {
      currentOption: null,
      product: this.value,
      showAlert: false,
      showPreview: false,
      optionkhaiwhan: "",
      currentPreview: null,
      quantity: 1,
      stock: [],
      option: null,
      selectedImage: null,
      loadingProduct: true,
      loading: false,
      productbundle: [],

      isImageFail: false,
      bubbletea: [],
      additional_price: 0,
      currentPhoto: null,
      gaigaoaddon: null,
      hasAddon: false,
      hasTopup: false,
      topups: [],
      remarkcount: 0,
      optionGaiGao: [],
      customerName: null,
      shippingAddress: null,
      customerPhone: null,
      sessiontoken: null,
    };
  },
  computed: {
    ...mapGetters({
      cart: "getCart",
      isWholesale: "getWholesaleStatus",
      wholesale: "getWholesale",
      theme: "getTheme",
    }),
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == "gaigao";
    },
    isCDS() {
      return this.pageProfile && this.$store.state.cds.includes(this.pageProfile.pageid);
    },
    isKhaiwhan() {
      return this.pageProfile && this.$store.state.khaiwhan.includes(this.pageProfile.pageid);
    },
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case "THB":
            return "฿";

          default:
            return "$";
        }
      }
      return "$";
    },
    productImages: function() {
      let images = [];
      if (this.product) {
        $.each(this.product.photourl.split(";;"), function(index, val) {
          images.push(val);
        });
        // this.previewImage =
        //   images.length > 0
        //     ? images[0]
        //     : "../assets/img/ecommerce/product_image_fallback@2x.png";
      }
      return images;
    },
    isOutOfStock: function() {
      let vm = this;
      if (vm.option) {
        if (parseInt(vm.option[2]) <= 0) {
          return true;
        }
        if (parseInt(vm.option[2]) < vm.quantity) {
          return true;
        }
        return false;
      }
      return true;
    },
    priceRange: function() {
      var min = 0;
      var max = 0;

      if (this.product.productstock.length <= 0) {
        min = this.product.price;
        max = this.product.price;
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][3];
            max = this.product.productstock[index][3];
          } else {
            if (this.product.productstock[index][3] > max) {
              max = this.product.productstock[index][3];
            }
            if (this.product.productstock[index][3] < min) {
              min = this.product.productstock[index][3];
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format("0,0.00");
      } else {
        return (
          this.currencySign +
          numeral(min).format("0,0.00") +
          " - " +
          this.currencySign +
          numeral(max).format("0,0.00")
        );
      }
    },
    discountPriceRange: function() {
      var min = 0;
      var max = 0;

      if (this.product.productstock.length <= 0) {
        min = this.product.discountprice;
        max = this.product.discountprice;
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][4];
            max = this.product.productstock[index][4];
          } else {
            if (this.product.productstock[index][4] > max) {
              max = this.product.productstock[index][4];
            }
            if (this.product.productstock[index][4] < min) {
              min = this.product.productstock[index][4];
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format("0,0.00");
      } else {
        return (
          this.currencySign +
          numeral(min).format("0,0.00") +
          " - " +
          this.currencySign +
          numeral(max).format("0,0.00")
        );
      }
    },
    discountPercentage: function() {
      var max = 0;

      if (this.product.productstock.length <= 0) {
        max = ((this.product.price - this.product.discountprice) / this.product.price) * 100;
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            max =
              ((this.product.productstock[index][3] - this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100;
          } else {
            var percent =
              ((this.product.productstock[index][3] - this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100;
            if (max < percent) {
              max = percent;
            }
          }
        }
      }

      return max;
    },
    totalBundle: function() {
      var vm = this;
      var quantity = 0;
      if (vm.isWholesale) {
        if (vm.cart) {
          vm.cart.map(function(product) {
            quantity += product.quantity;
          });
        }
        return quantity;
      }
      var products = vm.cart.filter(function(product) {
        return product.id == vm.product.id;
      });
      quantity = 0;
      products.map((p) => {
        quantity += p.quantity;
      });
      return quantity;
    },
    productstock: function() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.product.productstock;
      // .sort(function(a, b) {
      //   if (a[6] > b[6]) {
      //     return 1;
      //   } else if (a[6] < b[6]) {
      //     return -1;
      //   } else {
      //     return 0;
      //   }
      // });
    },
    isBearhouse() {
      return this.pageProfile && this.$store.state.bearhouse.includes(this.pageProfile.pageid);
    },
    hasBubbleTea() {
      return bearhousepackagehasbubble().includes(this.product.id);
    },
    productstockcategories() {
      try {
        return JSON.parse(this.product.productstockcategories);
      } catch (error) {
        return [];
      }
    },
    addonproducts() {
      return this.products.filter((el) => {
        return el.categoryid == 10625;
      });
    },
  },
  components: {
    vZoom,
    ModalProduct,
    Modal,
    ModalImage,
    VueperSlides,
    VueperSlide,
    Nl2br,
    // Carousel,
    Slide,
    Hooper,
    Pagination,
    Navigation,
    ProductOption,
    // Slide,
  },
  watch: {
    value: function() {
      let vm = this;
      this.product = this.value;
      //   this.getStock()
      if (this.productImages.length > 0) {
        this.selectedImage = this.productImages[0];
      }

      vm.setOption();
    },
    showModal: function(newVal) {
      if (newVal) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
  },
  created: function() {},
  mounted: function() {
    // this.getStock()
    let vm = this;
    if (this.productImages.length > 0) {
      this.selectedImage = this.productImages[0];
    }
    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid;
    }
    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken;
    }

    vm.getUserDetail().then(function(data) {
      vm.customerName = data.name;
      vm.customerPhone = data.phone;
      vm.shippingAddress = data.address;
      vm.remark = data.remark;
    });

    vm.setOption();

    if (this.isBearhouse) {
      this.bubbletea = bearhousebubbletea(this.products);
      for (let index = 0; index < this.bubbletea.length; index++) {
        this.bubbletea[index].quantity = 0;
      }
    }

    this.getProductBundle();

    if (this.isGaiGao) {
      var topupproducts = this.products.filter((el) => {
        return el.categoryid == 10431;
      });
      this.topups = JSON.parse(JSON.stringify(topupproducts));
      for (let index = 0; index < this.topups.length; index++) {
        this.$set(this.topups[index], "quantity", 0);
      }

      this.hasAddon = this.product.description.includes("แลกเครื่องเคียง");
      this.hasTopup = this.product.description.includes("เครื่องเคียงได้");
      var res = this.product.description.match(/เลือกได้ \d+ ซอส/g);
      if (res) {
        var count = res[0].match(/\d+/g);
        this.remarkcount = parseInt(count);
      }
    }

    vm.loadingProduct = false;
  },
  methods: {
    getUserDetail: function() {
      let vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig("serverUrl") +
              "lastorderaddress?pageid=" +
              vm.pageProfile.pageid +
              "&userid=" +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data);
              } else {
                reject();
              }
            } else {
              reject();
              // console.log(response);
            }
          });
      });
    },
    changeAddon(value) {
      this.gaigaoaddon = value;
      this.updateTopupPrice();
    },
    onChangeOption(type) {
      var stock = this.productstock.find((el) => {
        // console.log(el[1]);
        return el[1] == type;
      });

      if (stock) {
        this.option = stock;
        this.quantity = 1;
      } else {
        this.option = null;
        this.quantity = 1;
      }
    },
    async onViewStockPhoto(val) {
      await this.$nextTick();
      this.currentPhoto = val;
    },
    updateBubblePrice() {
      var price = 0;

      if (this.bubbletea && this.bubbletea.length > 0) {
        this.bubbletea.map((el) => {
          if (el.productstock.length > 0) {
            price += el.productstock[0][4] * el.quantity;
          } else {
            price += el.discountprice * el.quantity;
          }
        });
      }
      this.additional_price = price;
    },
    updateTopupPrice() {
      var price = 0;

      if (this.topups && this.topups.length > 0) {
        this.topups.map((el) => {
          if (el.productstock.length > 0) {
            price += el.productstock[0][4] * el.quantity;
          } else {
            price += el.discountprice * el.quantity;
          }
        });
      }
      if (
        this.gaigaoaddon &&
        this.gaigaoaddon.productstock.length > 0 &&
        this.gaigaoaddon.productstock[0][2] > 0
      ) {
        price += this.gaigaoaddon.productstock[0][4];
      }
      this.additional_price = price;
    },
    addBubbleCount(index) {
      this.$set(this.bubbletea[index], "quantity", this.bubbletea[index].quantity + 1);
      this.$forceUpdate();
      this.updateBubblePrice();
    },
    removeBubbleCount(index) {
      this.$set(this.bubbletea[index], "quantity", this.bubbletea[index].quantity - 1);
      this.$forceUpdate();
      this.updateBubblePrice();
    },
    addTopupCount(index) {
      this.$set(this.topups[index], "quantity", this.topups[index].quantity + 1);
      this.$forceUpdate();
      this.updateTopupPrice();
    },
    removeTopupCount(index) {
      this.$set(this.topups[index], "quantity", this.topups[index].quantity - 1);
      this.$forceUpdate();
      this.updateTopupPrice();
    },
    getProductBundle: function() {
      let vm = this;
      return new Promise((resolve, reject) => {
        let url = config.getConfig("serverUrl") + "productbundle?productid=" + vm.product.id;
        axios.get(url).then((response) => {
          response = response.data;
          if (response.responsecode == 200) {
            vm.productbundle = response.productbundlelist;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    onPreviewImgError: function() {
      this.isImageFail = true;
      //  this.previewImage = "../assets/img/ecommerce/product_image_fallback@2x.png"
    },
    setOption: function() {
      let vm = this;
      if (vm.product && vm.product.productstock && vm.product.productstock.length > 0) {
        vm.option = null;
        $.each(vm.productstock, function(index, val) {
          if (val && parseInt(val[2]) > 0) {
            vm.option = val;
            vm.currentOption = vm.option[1];
            return false;
          }
        });
      } else {
        vm.option = null;
      }
    },
    close: async function() {
      // let vm = this;

      let isClose = true;
      // if (this.$store.state.cds.includes(this.pageProfile.pageid)) {
      //   let result = await this.$swal({
      //     title: "ยืนยันไม่สั่งสินค้านี้",
      //     type: "info",
      //     confirmButtonText: this.$t("Confirm"),
      //     cancelButtonText: this.$t("Cancel"),
      //     showCancelButton: true,
      //     reverseButtons: true,
      //   });

      //   if (result.value) {
      //     isClose = true;
      //   } else {
      //     isClose = false;
      //   }
      // }

      if (isClose) {
        this.closeWindow();
      }
    },
    closeWindow() {
      if (window.history.length == 0) {
        this.showModal = false;
        this.$emit("close");
      } else {
        window.history.back();
      }
    },
    addCount: function() {
      if (!this.option || this.option == null) {
        return false;
      }
      if (this.quantity < this.option[2]) {
        this.quantity++;
      }
    },
    removeCount: function() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    async addToCart() {
      let vm = this;
      // if (vm.cart.length >= 10) {
      //   vm.showAlert = true;
      //   return false;
      // }
      if (vm.isOutOfStock) {
        return false;
      }
      var result = await this.$validator.validate();
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput();
        return false;
      }
      vm.loading = true;

      var price = vm.option[3];
      var discountprice = vm.option[4];
      var option = { ...vm.option };
      if (vm.isKhaiwhan) {
        if (vm.productstock.length > 1 && !vm.optionkhaiwhan) {
          // DO nothing
        } else {
          option[1] = vm.optionkhaiwhan ? option[1] + " - " + vm.optionkhaiwhan : "Normal";
        }
      }
      if (vm.isCDS) {
        var productincart = vm.cart.find((el) => {
          return el.id == vm.product.id && el.option == option[1];
        });

        if (productincart && productincart.quantity + vm.quantity > 10) {
          await vm.$swal({
            title: vm.$t("คุณสามารถซื้อสินค้าชนิดนี้ได้ไม่เกิน 10 ชิ้นเท่านั้น"),
            type: "warning",
            confirmButtonText: vm.$t("Confirm"),
            cancelButtonText: vm.$t("cancel"),
            reverseButtons: true,
          });
          vm.loading = false;
          return false;
        }
      }

      if (vm.isGaiGao) {
        if (vm.productstock.length > 1 && !vm.optionGaiGao) {
          // DO nothing
        } else {
          option[1] =
            vm.optionGaiGao && vm.optionGaiGao.length > 0
              ? option[1] + " - " + vm.optionGaiGao.join(",")
              : option[1];
        }
      }

      let item = {
        quantity: vm.quantity,
        option: option,
        buttonaction: vm.product.buttonaction,
        buttonname: vm.product.buttonname,
        buttonurl: vm.product.buttonurl,
        categoryid: vm.product.categoryid,
        currency: vm.product.currency,
        description: vm.product.description,
        id: vm.product.id,
        keyword: vm.product.keyword,
        name: vm.product.name,
        pageid: vm.product.pageid,
        photohash: vm.product.photohash,
        photourl: vm.option[7] ? vm.option[7] : vm.product.photourl,
        price: price,
        priority: vm.product.priority,
        subcategoryid: vm.product.subcategoryid,
        discountprice: discountprice,
        productbundle: vm.productbundle,
      };

      vm.setOption();

      vm.$emit("addToCart", {
        item: item,
        loading: async function() {
          await vm.handleSubmit();
          vm.loading = false;
        },
      });
    },
    addAddonToCart(product) {
      let vm = this;

      var price = 0;
      var discountprice = 0;
      vm.loading = true;

      if (product.productstock.length > 0) {
        price = product.productstock[0][3];
        discountprice = product.productstock[0][4];
      } else {
        price = product.price;
        discountprice = product.discountprice;
      }
      var option = product.productstock.length > 0 ? product.productstock[0] : null;
      let item = {
        quantity: product.quantity,
        option: option,
        buttonaction: product.buttonaction,
        buttonname: product.buttonname,
        buttonurl: product.buttonurl,
        categoryid: product.categoryid,
        currency: product.currency,
        description: product.description,
        id: product.id,
        keyword: product.keyword,
        name: product.name,
        pageid: product.pageid,
        photohash: product.photohash,
        photourl: product.photourl,
        price: price,
        priority: product.priority,
        subcategoryid: product.subcategoryid,
        discountprice: discountprice,
        productbundle: [],
      };
      vm.$emit("addToCart", {
        item: item,
        loading: function() {
          vm.loading = false;
        },
      });
    },
    getStock: function() {
      let vm = this;
      axios
        .get(config.getConfig("serverUrl") + "productstock?productid=" + vm.product.id)
        .then((response) => {
          // JSON responses are automatically parsed.
          response = response.data;
          if (response.responsecode == 200) {
            vm.stock = response.productstocklist;
            vm.setOption();
          } else {
            // console.log(response);
          }
        });
    },
    async handleSubmit() {
      let vm = this;

      var total = vm.option[4];
      var payment = null;
      let data = {
        amount: total
          .toFixed(2)
          .toString()
          .replace(".", ""),
        pageid: vm.pageProfile.pageid,
        userid: vm.userid,
        app: "facebook",
        name: vm.customerName,
        address: vm.shippingAddress,
        phone: vm.customerPhone,
        payment: payment,
        nameaddress: vm.customerName + " , " + vm.shippingAddress + " , " + vm.customerPhone,
        shippingtype: vm.shippingType ? vm.shippingType.type : null,
        note: null,
        remark: null,
        shippingcharge: (vm.shippingType ? vm.shippingType.value : 0)
          .toFixed(2)
          .toString()
          .replace(".", ""),
        total: total
          .toFixed(2)
          .toString()
          .replace(".", ""),
      };

      let url = config.getConfig("serverUrl") + "banktransfernotify";
      if (vm.sessiontoken != null || vm.sessiontoken != "") {
        url += "?sessiontoken=" + vm.sessiontoken;
      }
      var response = await axios.post(url, data);

      try {
        // JSON responses are automatically parsed.
        response = response.data;
        if (response.responsecode == 200) {
          await vm.$store.dispatch("deleteAllItemsInCart");
          // eslint-disable-next-line
          if (vm.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            await vm.$liff
              .sendMessages([
                {
                  type: "text",
                  text: "Order: " + response.orderid,
                },
              ])
              .then(() => {});
            // eslint-disable-next-line no-undef
            vm.$liff.closeWindow();
          } else {
            // eslint-disable-next-line no-undef
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error() {
                window.close();
              }
            );
          }
        } else if (response.responsecode == 400) {
          await vm.$swal({
            title: vm.$t("Error"),
            text: vm.$t(response.reason),
            type: "error",
            confirmButtonText: vm.$t("Confirm"),
            cancelButtonText: vm.$t("Cancel"),
            reverseButtons: true,
          });
        } else if (response.responsecode == 201) {
          await vm.$store.dispatch("deleteAllItemsInCart");
          let url = "/ecommerce/" + vm.pagename;
          if (vm.userid && vm.userid != null && vm.userid != "") {
            url += "?userid=" + vm.userid;
          }
          vm.$router.push({ path: url });
        } else {
          await vm.$swal({
            title: vm.$t("Error"),
            text: vm.$t("Something went wrong. Please try it again."),
            type: "error",
            confirmButtonText: vm.$t("Confirm"),
            cancelButtonText: vm.$t("Cancel"),
            reverseButtons: true,
          });
        }
      } catch (error) {
        console.log(error);
        await vm.$swal({
          title: vm.$t("Error"),
          text: vm.$t("Something went wrong. Please try it again."),
          type: "error",
          confirmButtonText: vm.$t("Confirm"),
          cancelButtonText: vm.$t("Cancel"),
          reverseButtons: true,
        });
      }
    },
  },
};
</script>
<style lang="scss">
.full-width {
  .v-input__control {
    width: 100% !important;
  }
}
</style>
